import React, { Suspense } from "react";
import PropTypes from "prop-types";
import Grid from "../../layout/Grid";
import aiIconAnimation from "../../assets/aiIconAnimation.json";
import { lazyWithRetry } from "../../utils/LazyWithRetry";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles(() => ({
  aiIconAnimationContainer: {
    height: "50.4px",
    width: "90px",
    position: "absolute",
    zIndex: 10,
    marginTop: "-20px",
    marginLeft: "-20px"
  }
}));
const Lottie = lazyWithRetry(() => import("lottie-react"));
const AIIconAnimation = ({
  id = "ai-icon-axnimation-default-id"
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    className: classes.aiIconAnimationContainer,
    id: id
  }, /*#__PURE__*/React.createElement(Suspense, null, /*#__PURE__*/React.createElement(Lottie, {
    animationData: aiIconAnimation,
    loop: true,
    autoplay: true
  })));
};
AIIconAnimation.propTypes = {
  id: PropTypes.string
};
export default AIIconAnimation;